import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
//import data from '../../assets/data/listUser';
import Datatable_user from '../common/datatable_user'

export class List_user extends Component {
    constructor(props){
       super(props);
       this.state = {
        open: true,
        user:[]
        };
    }
   
    componentDidMount() {
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }

        fetch(`${process.env['REACT_APP_HOST']}/api/users`)
            .then((response) => response.json())
            .then(result=>{
            this.setState({ user:result});
        });
    }
 

    render() {
       
        return (
            <Fragment>
                <Breadcrumb title="User List" parent="Users" />
                {
                <div className="container-fluid">
                    <div className="card">
                        {/* <div className="card-header">
                            <h5>User Details</h5>
                        </div> */}
                        <div className="card-body">
                            <div className="btn-popup pull-right">
                                <Link to="/users/create-user" className="btn btn-secondary">Create User</Link>
                            </div>
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                                <Datatable_user
                                    multiSelectOption={false}
                                    myData={this.state.user}
                                    pageSize={10}
                                    pagination={true}
                                    class="-striped -highlight"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
                 }
            </Fragment>
        )
    }
}

export default List_user
